<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import MainProvider from '@/components/provider/MainProvider.vue'
import ResolverProvider from '@/components/provider/ResolverProvider.vue'
import DialogProvider from '@/components/provider/DialogProvider.vue'

const route = useRoute()
const router = useRouter()
const provider = ref()

onMounted(async () => {
  await router.isReady()
  setProvider()
})

const setProvider = () => {
  switch (route.meta.provider) {
    case 'resolver': {
      provider.value = ResolverProvider
      break
    }
    case 'dialog': {
      provider.value = DialogProvider
      break
    }
    default: {
      provider.value = MainProvider
    }
  }
}
</script>

<template>
  <Component v-if="provider" :is="provider">
    <RouterView name="navbar" />
    <Suspense>
      <RouterView v-slot="{ Component }">
        <KeepAlive :include="['HomeView']">
          <Component :is="Component" />
        </KeepAlive>
      </RouterView>
    </Suspense>
  </Component>
</template>
